import './Header.css';

export default function Header() {
    return (
        <header className="app-header">
            <div className="header-logo">
                <img src="https://www.gssd.ca/uploads/gssdlogo1.png" alt="Logo" className="logo" />
            </div>
            <p className="header-title">Student Registration Form</p>
        </header>
    )
}